import React, { useState } from 'react';
import { WidgetProps } from '@rjsf/core';
import { iconAllSidesSvg, iconEachSideSvg } from '../../assets/images';
import UnitSelector from '../BaseComponents/UnitSelector';
import CustomCheckbox from './CustomCheckbox';

const getSidesvalues = (value: string) => {
    const sides = value && value.split(' ');

    if (sides && sides.length) {
        return sides.length === 1
            ? {
                  allSidesValue: sides[0],
                  top: null,
                  right: null,
                  bottom: null,
                  left: null,
              }
            : {
                  allSidesValue: null,
                  top: sides[0],
                  right: sides[1],
                  bottom: sides[2],
                  left: sides[3],
              };
    }

    return {
        allSidesValue: '0px',
        top: null,
        right: null,
        bottom: null,
        left: null,
    };
};

const BoxModelProperties = (props: WidgetProps) => {
    const { schema, value, onChange } = props;
    const { allSidesValue, top, left, bottom, right } = getSidesvalues(value);
    const [checked, setChecked] = useState<boolean>(!!value);
    const [isSelected, setSelected] = useState<string>(allSidesValue ? 'allSides' : 'eachSides');
    const [allSides, setAllSides] = useState<string>(allSidesValue || '0px');
    const [sideTop, setSideTop] = useState<string>(top || '0px');
    const [sideLeft, setSideLeft] = useState<string>(left || '0px');
    const [sideBottom, setSideBottom] = useState<string>(bottom || '0px');
    const [sideRight, setSideRight] = useState<string>(right || '0px');

    const handleCheckboxChange = (e: any) => {
        setChecked(e);
        !e && onChange('');
    };

    const handleBorderChange = (value: string) => (_event: React.MouseEvent) => {
        setSelected(value);
    };

    const handleAllSideChange = (e: any) => {
        setAllSides(e);
        onChange(`${e}`);
    };

    const handleTopChange = (e: any) => {
        setSideTop(e);
        onChange(`${e} ${sideLeft} ${sideBottom} ${sideRight}`);
    };

    const handleLeftChange = (e: any) => {
        setSideLeft(e);
        onChange(`${sideTop} ${sideRight} ${sideBottom} ${e}`);
    };

    const handleBottomChange = (e: any) => {
        setSideBottom(e);
        onChange(`${sideTop} ${sideLeft} ${e} ${sideRight}`);
    };

    const handleRightChange = (e: any) => {
        setSideRight(e);
        onChange(`${sideTop} ${e} ${sideBottom} ${sideLeft}`);
    };

    return (
        <div className="box-model">
            <CustomCheckbox {...props} schema={schema} onChange={handleCheckboxChange} />
            {checked && (
                <div className="box-model-content">
                    <div className="box-icons">
                        <img
                            className={`border-icon ${
                                isSelected === 'allSides' ? 'selected-icon' : ''
                            }`}
                            id={'border-all'}
                            src={iconAllSidesSvg}
                            alt="border-icon-all"
                            onClick={handleBorderChange('allSides')}
                        />
                        <img
                            className={`border-icon ${
                                isSelected === 'eachSides' ? 'selected-icon' : ''
                            }`}
                            id={'border-each'}
                            src={iconEachSideSvg}
                            alt="border-icon-each"
                            onClick={handleBorderChange('eachSides')}
                        />
                    </div>
                    {isSelected === 'allSides' && (
                        <div className="box-model-inputs">
                            <UnitSelector
                                value={allSides}
                                defaultValue={schema.default as string}
                                onChange={handleAllSideChange}
                            />
                        </div>
                    )}
                    {isSelected === 'eachSides' && (
                        <div className="box-model-inputs">
                            <UnitSelector
                                value={sideTop}
                                defaultValue={schema.default as string}
                                onChange={handleTopChange}
                            />
                            <UnitSelector
                                value={sideRight}
                                defaultValue={schema.default as string}
                                onChange={handleRightChange}
                            />
                            <UnitSelector
                                value={sideBottom}
                                defaultValue={schema.default as string}
                                onChange={handleBottomChange}
                            />
                            <UnitSelector
                                value={sideLeft}
                                defaultValue={schema.default as string}
                                onChange={handleLeftChange}
                            />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default BoxModelProperties;
